module.exports = __webpack_public_path__ + "fonts/PlayfairDisplay-Italic.e07c93f.ttf";